import { render, staticRenderFns } from "./EarthquakeFeaturedCard.vue?vue&type=template&id=663d9f8e&"
import script from "./EarthquakeFeaturedCard.vue?vue&type=script&lang=js&"
export * from "./EarthquakeFeaturedCard.vue?vue&type=script&lang=js&"
import style0 from "./EarthquakeFeaturedCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports